import { createActionConst } from '../../../utils/action.utils';

const USER_TENANTS_NAMESPACE = 'TENANTS';

export const SWITCH_USER_TENANT = createActionConst(USER_TENANTS_NAMESPACE, 'SWITCH_USER_TENANT');
export const SEARCH_USER_TENANTS = createActionConst(USER_TENANTS_NAMESPACE, 'SEARCH_USER_TENANTS');
export const ADD_USER_TO_TENANT = createActionConst(USER_TENANTS_NAMESPACE, 'ADD_USER_TO_TENANT');
export const CREATE_TENANT = createActionConst(USER_TENANTS_NAMESPACE, 'CREATE_TENANT');

export const STORE_TENANTS = createActionConst(USER_TENANTS_NAMESPACE, 'STORE_TENANTS');
export const CLEAR_TENANTS = createActionConst(USER_TENANTS_NAMESPACE, 'CLEAR_TENANTS');
